module.exports = __webpack_public_path__ + "static/media/bookmark.b3a1afbe.svg";